import {z} from 'zod';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {
  ConditionCategory,
  ConditionOperatorKey,
  ConditionType,
} from 'common/src/modules/conditions/conditions.types';
import {baseCardSchema} from './baseSchemas';
import {MacroItemTypeValue} from 'common/src/modules/macros/macros.types';

const conditionOutputSchema = z.object({
  name: z.string().describe('The name of the output'),
  textValues: z
    .array(z.string())
    .nullable()
    .describe('Array of textual values that will be used to evaluate the condition'),
  numericValues: z
    .array(z.number())
    .nullable()
    .describe('Array of numeric values that will be used to evaluate the condition'),
  booleanValue: z
    .boolean()
    .nullable()
    .describe('Boolean value that will be used to evaluate the condition'),
  dateValues: z
    .array(
      z
        .string()
        .describe(
          'Date value in ISO format, converted to UTC timezone (add Z to the end of the date string)',
        ),
    )
    .nullable()
    .describe(
      'Array of date values that will be used to evaluate the condition, in ISO format, converted to UTC timezone (add Z to the end of the date string)',
    ),
  datesRange: z
    .object({
      from: z
        .string()
        .describe(
          'Start date/time in ISO format, converted to UTC timezone (add Z to the end of the date string)',
        ),
      to: z
        .string()
        .describe(
          'End date/time in ISO format, converted to UTC timezone (add Z to the end of the date string)',
        ),
    })
    .nullable()
    .describe(
      'Range of date values that will be used to evaluate the condition, in ISO format, converted to UTC timezone (add Z to the end of the date string)',
    ),
});

export const conditionCardSchema = baseCardSchema.extend({
  type: z.literal(NodeType.CONDITION),
  condKey: z.string(),
  condKeyType: z.nativeEnum(MacroItemTypeValue).describe('Type of the condition key'),
  condOperator: z.nativeEnum(ConditionOperatorKey),
  outputs: z
    .array(conditionOutputSchema)
    .describe(
      'Array of outputs for the condition. Add only the required outputs or update as requested, DO NOT ADD ANY FALLBACK/SYSTEM OUTPUT',
    ),
  categories: z
    .array(z.nativeEnum(ConditionCategory))
    .describe('Array of categories, derived from the selected signal'),
  signalDescription: z.string().describe('Description of the selected signal'),
  conditionType: z.nativeEnum(ConditionType).describe('Type of the condition'),
});
